import * as S from './styles'
import { RawHexaV2Dialog } from '..'
import { HexaV2DialogProps } from './types'

const HexaV2Dialog = (props: HexaV2DialogProps) => {
  return (
    <S.Wrapper>
      <RawHexaV2Dialog {...props} />
    </S.Wrapper>
  )
}

export default HexaV2Dialog
